__turbopack_context__.v({
  "container": "SelectInput-module__ZgSnCa__container",
  "contentWrapper": "SelectInput-module__ZgSnCa__contentWrapper",
  "label": "SelectInput-module__ZgSnCa__label",
  "notFoundText": "SelectInput-module__ZgSnCa__notFoundText",
  "option": "SelectInput-module__ZgSnCa__option",
  "optionSelect": "SelectInput-module__ZgSnCa__optionSelect",
  "options": "SelectInput-module__ZgSnCa__options",
  "popoverContainer": "SelectInput-module__ZgSnCa__popoverContainer",
  "searchBar": "SelectInput-module__ZgSnCa__searchBar",
  "select": "SelectInput-module__ZgSnCa__select",
  "trigger": "SelectInput-module__ZgSnCa__trigger",
});
